export default class HttpModule {
  constructor(url) {
    this.url = url;
  }
  post(options) {
    if ('url' in options) {
      delete options.url;
    }
    if ('method' in options) {
      delete options.method;
    }
    options = Object.assign(Object.assign({}, options), {
      url: this.url,
      method: 'POST'
    });
    lm.fetch(options);
  }
}